export default function NotificationsScreen() {
    return <></>;
}
